import { PlanPageShape, TDynamicVariable } from "@shared/types";
import { TMinimumProductConfig, TMinimumShape } from "../types";
import { roundNumber } from "../utils";

export const calculateNumber = (
  variable: TDynamicVariable,
  config: {
    ProductConfiguration: TMinimumProductConfig;
    Shapes: TMinimumShape[];
    appendUnit?: boolean;
  }
) => {
  if (typeof variable.number !== "number") {
    return 0;
  }
  if (config.appendUnit && variable.unit) {
    return `${roundNumber(variable.number, config)}${variable.unit}`;
  }
  return roundNumber(variable.number, config);
};
